import { Link } from "react-router-dom";
import "./RegistrationSuccess.css";

function RegistrationSuccess() {

    return (

        <div className="registration-success">

            <div className="success-card">

                <div className="success-icon">

                    🎉

                </div>

                <h2>

                    Registration Submitted Successfully

                </h2>

                <p>

                    Thank you for registering with <b>HomeFoods</b>.

                </p>

                <p>

                    Your application has been received successfully.

                </p>

                <div className="status-box">

                    <h3>

                        Current Status

                    </h3>

                    <span>

                        🟡 Pending Admin Verification

                    </span>

                </div>

                <div className="timeline">

                    <div>✅ Application Submitted</div>

                    <div>⏳ Admin Verification</div>

                    <div>🚀 Business Dashboard Activation</div>

                </div>

                <p className="review-text">

                    Estimated verification time:

                    <b> 24 – 48 Hours</b>

                </p>

                <Link
                    to="/home"
                    className="home-btn"
                >

                    Back to Home

                </Link>

            </div>

        </div>

    );

}

export default RegistrationSuccess;